// Think5WhysHelp.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';

const AboutThink5WhysLearning = () => {
  const topics = [
    {
      title: 'Think5Whys Learning Introduction',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. About:</strong>
            The Learning module is your gateway to a wealth of knowledge. Access various resources, whitepapers,
            videos, and courses designed to enhance critical thinking skills using the Think5Whys framework.
            Elevate your understanding and application of this powerful methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. Need / Philosophy:</strong>
          </p>
          <div>
            <p>Why 5 Why Analysis?</p>

            <p>Background</p>

            <p>Founder's Vision</p>

          </div>
        </div>
      ),
    },
    {
      title: 'Learning Building Blocks',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. EBooks:</strong>
            Immerse yourself in insightful content with a collection of eBooks. Explore in-depth materials covering various
            aspects of critical thinking and the 5 Whys methodology.
          </p>

          <p>
            <strong style={{ color: 'black' }}>2. White Papers:</strong>
            Delve into comprehensive White Papers that provide detailed analyses, case studies, and valuable insights related
            to critical thinking, root cause analysis, and effective decision-making.
          </p>

          <p>
            <strong style={{ color: 'black' }}>3. QnA:</strong>
            Engage in a dynamic Question and Answer section. Pose queries, participate in discussions, and gain deeper insights
            by interacting with experts and the Think5Whys community.
          </p>

          <p>
            <strong style={{ color: 'black' }}>4. Videos:</strong>
            Visualize concepts and methodologies through a curated collection of educational videos. Enhance your learning
            experience with engaging visual content that simplifies complex ideas.
          </p>

          <p>
            <strong style={{ color: 'black' }}>5. Templates:</strong>
            Access a repository of practical templates designed to facilitate the application of the 5 Whys methodology.
            Utilize these tools to streamline your problem-solving processes.
          </p>

          <p>
            <strong style={{ color: 'black' }}>6. Workbooks:</strong>
            Enhance your practical skills with interactive workbooks. Apply theoretical knowledge through hands-on exercises
            and real-world scenarios, reinforcing your understanding of critical thinking.
          </p>

          <p>
            <strong style={{ color: 'black' }}>7. Assignments for All:</strong>
            Sharpen your critical thinking skills through assignments tailored for various proficiency levels. These assignments
            cover diverse scenarios and help you apply the 5 Whys methodology effectively.
          </p>

          <p>
            <strong style={{ color: 'black' }}>8. Certification Test:</strong>
            Test your understanding and proficiency by taking the Certification Test. Validate your mastery of critical thinking
            concepts and earn official recognition for your achievements.
          </p>

          <p>
            <strong style={{ color: 'black' }}>9. My Certificate:</strong>
            View and showcase your hard-earned Think5Whys certificates. Keep track of your certifications and share your
            accomplishments with your network.
          </p>

          <p>
            <strong style={{ color: 'black' }}>10. Enroll for Live Workshop:</strong>
            Immerse yourself in a dynamic learning experience by enrolling in live workshops. Interact with experts,
            participate in discussions, and stay updated on the latest developments in critical thinking methodologies.
          </p>
        </div>
      ),
    },
    {
      title: 'Certification Benefits',
      description: (
        <div>
          <div><strong>Think5Whys certification offers numerous benefits:</strong></div>
          <p>
            <ul>
              <li><strong>1. Enhanced Problem-Solving Skills:</strong> Certification equips individuals with the structured approach of 5 Whys Analysis, enabling them to identify root causes effectively and develop innovative solutions.</li>
              <li><strong>2. Critical & Deep Thinking Development:</strong> Participants learn to think critically, analyze situations comprehensively, and make informed decisions by delving into the underlying causes.</li>
              <li><strong>3. Professional Recognition:</strong> Certification adds credibility to individuals' profiles, distinguishing them as adept problem-solvers and critical thinkers in their respective fields.</li>
              <li><strong>4. Career Advancement:</strong> Employers value employees with problem-solving skills, making Think5Whys certification a valuable asset for career growth and advancement opportunities.</li>
              <li><strong>5. Improved Efficiency:</strong> Certified individuals contribute to more efficient processes within their organizations by addressing issues at their core, leading to enhanced productivity and performance.</li>
              <li><strong>6. Organizational Benefits:</strong> Organizations benefit from having certified employees who can streamline processes, reduce errors, and contribute to overall operational excellence.</li>
              <li><strong>7. Personal Growth:</strong> Certification fosters personal growth by instilling a mindset of continuous improvement and providing individuals with the tools to overcome challenges effectively.</li>
              <li><strong>8. Global Recognition:</strong> Think5Whys certification is recognized globally, offering individuals the flexibility to apply their skills and knowledge across different industries and geographic locations.</li>
              <li><strong>9. Lifelong Learning:</strong> Certified individuals become part of a community committed to lifelong learning and continuous improvement, gaining access to ongoing resources, updates, and support from the Think5Whys ecosystem.</li>
            </ul>
          </p>
        </div>
      ),
    },
    {
      title: 'Think5Whys Workshop',
      description: (
        <div>
          <div>
            The Think5Whys Workshop focuses on cultivating deep thinking skills to enhance problem-solving abilities and increase success probabilities across various life domains, including personal, family, professional, and social aspects. Through engaging sessions and interactive activities, participants learn to apply the renowned "5 Whys" technique to dissect complex issues, uncover root causes, and devise effective solutions. The workshop provides practical strategies and tools to foster critical thinking, creativity, and resilience, empowering individuals to navigate challenges with clarity, confidence, and purpose. By leveraging deep thinking principles, participants gain valuable insights and develop a proactive mindset conducive to achieving their goals and aspirations.
          </div><br />
          <div>
            <p><strong>Online Workshop:</strong></p><br />
            <ol>
              <li>Virtual Classroom</li>
              <li>Live Video Sessions</li>
              <li>Chat and Messaging</li>
              <li>Polls and Quizzes</li>
              <li>Breakout Rooms</li>
              <li>Recording and Playback</li>
              <li>Resource Library</li>
              <li>Feedback and Evaluation</li>
              <li>Certificate of Completion</li>
            </ol>
          </div>
          <br />
          <div>
            <p><strong>Offline Workshop:</strong></p><br />
            <ul>
              <li>Physical Classroom</li>
              <li>In-person Instruction</li>
              <li>Hands-on Activities</li>
              <li>Group Discussions</li>
              <li>Q&A Sessions</li>
              <li>Feedback and Evaluation</li>
              <li>Certificate of Completion</li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: 'Online Book Features',
      description: (
        <div>
          <p>
            <strong style={{ color: 'black' }}>1. Book Display:</strong>
            Displaying the content of a book fetched from a JSON file or database.
          </p>
          <p>
            <strong style={{ color: 'black' }}>2. Pagination:</strong>
            Implementing pagination to navigate through the book's pages.
          </p>
          <p>
            <strong style={{ color: 'black' }}>3. Text-to-Speech:</strong>
            Adding a feature to read the book's content aloud using a free and open-source library.
          </p>
          <p>
            <strong style={{ color: 'black' }}>4. Flipbook Animation:</strong>
            Incorporating a flipbook animation for page turning.
          </p>
          <p>
            <strong style={{ color: 'black' }}>5. Ratings:</strong>
            Allowing users to rate the book.
          </p>
          <p>
            <strong style={{ color: 'black' }}>6. Review Comments:</strong>
            Enabling users to leave comments and reviews about the book.
          </p>
          <p>
            <strong style={{ color: 'black' }}>7. Show Reviews & Ratings:</strong>
            Displaying the aggregated reviews and ratings for the book.
          </p>
          <p>
            <strong style={{ color: 'black' }}>8. Responsive Styling:</strong>
            Applying responsive styles to ensure the UI adapts to different screen sizes.
          </p>
          <p>
            <strong style={{ color: 'black' }}>9. Notes Section:</strong>
            Adding a feature for users to highlight and save sections of the book as notes.
          </p>
          <p>
            <strong style={{ color: 'black' }}>10. Highlighter:</strong>
            Allowing users to highlight text in different colors and saving the highlights for future reference.
          </p>
        </div>
      )
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Think5Whys Help Center</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutThink5WhysLearning;


